var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-body px-0" }, [
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between align-items-center mb-3",
        },
        [
          _vm.item.status
            ? _c("div", {}, [
                _c(
                  "div",
                  {
                    staticClass: "badge badge-status badge-status-sm",
                    style: {
                      color: _vm.resolvePath(_vm.item, "status.color"),
                      "background-color": _vm.$root.$helper.color.convertHex(
                        _vm.resolvePath(_vm.item, "status.color")
                      ),
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.resolvePath(_vm.item, "status.name"))),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex" }, [
            _c("div", {}, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-link shadow-none text-decoration-none text-nowrap min-w-auto p-0 m-0",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.selectFeature(_vm.item)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "text-btn-link" }, [
                    _vm._v(_vm._s(_vm.$t(_vm.txtLinkMap))),
                  ]),
                ]
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.item.type
        ? _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.resolvePath(_vm.item, "type.name")) +
                "\n\t\t"
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row no-gutters" }, [
        _c("div", { staticClass: "col" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("p", { staticClass: "label" }, [
              _vm._v(
                "\n\t\t\t\t\t\t" +
                  _vm._s(_vm.$t(_vm.labelCode)) +
                  "\n\t\t\t\t\t"
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n\t\t\t\t\t\t" +
                  _vm._s(_vm.resolvePath(_vm.item, "code")) +
                  "\n\t\t\t\t\t"
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.feature
          ? _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("p", { staticClass: "label" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(_vm.$t(_vm.labelFeature)) +
                      "\n\t\t\t\t\t"
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n\t\t\t\t\t\t" + _vm._s(_vm.feature) + "\n\t\t\t\t\t"
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("p", { staticClass: "label" }, [
              _vm._v(
                "\n\t\t\t\t\t\t" +
                  _vm._s(_vm.$t(_vm.labelCreatedAt)) +
                  "\n\t\t\t\t\t"
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.createdAt) + "\n\t\t\t\t\t"),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.address
        ? _c("div", { staticClass: "row no-gutters" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("p", { staticClass: "label" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(_vm.$t(_vm.labelAddress)) +
                      "\n\t\t\t\t\t"
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n\t\t\t\t\t\t" + _vm._s(_vm.address) + "\n\t\t\t\t\t"
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.description
        ? _c("div", { staticClass: "row no-gutters" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("p", { staticClass: "label" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t(_vm.labelDescription)) +
                        "\n\t\t\t\t\t"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "fade" } },
                    [
                      _c("read-more", {
                        staticClass: "read-more",
                        attrs: {
                          moreStr: _vm.$t("global.read-more"),
                          lessStr: _vm.$t("global.read-less"),
                          text: _vm.description,
                          maxChars: 186,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.daysOverdue
        ? _c("div", { staticClass: "row no-gutters" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "div",
                {
                  staticClass:
                    "alert alert-danger small text-lowercase font-weight-bold",
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" + _vm._s(_vm.txtDaysOverdue) + "\n\t\t\t\t"
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }